<template>
	<div id="HomePage">
		<div id="header" class="header">
			<div class="switch-language">
				<!-- <el-dropdown>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="toEuropean">European Tour</el-dropdown-item>
            <el-dropdown-item @click.native="toAsian">Asian Tour</el-dropdown-item>
            <el-dropdown-item @click.native="toOWGR">OWGR</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->

				<div id="translate" class="translate" v-if="pathName === '/openQualificationPayment' || pathName === '/openQualificationDiffPayment'?false:true">
					<a class="ignore chinese"
						@click="enBtn('zh-CN','chinese_simplified')" style="cursor:pointer;">简体中文</a>
					<a class="ignore english"
						@click="chBtn('en','English')" style="cursor:pointer;">English</a>
				</div>
			</div>
			<div v-show="lang === 'zh-CN'?true:false">
				<span class="login" v-show='logOutShow' @click='personalCenter'><i
						class="el-icon-s-custom"></i>个人中心</span>
				<span class="login" @click="login" v-show='logShow'> <i class="el-icon-s-custom"></i>球员登录</span>
				<span class="login" @click="loginOut" v-show='logOutShow'> 退出登录</span>
			<!-- 	<a href='https://static.sadong.net/%E9%AB%98%E5%B0%94%E5%A4%AB-%E5%AE%98%E7%BD%91%E7%94%A8%E6%88%B7%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf'
					target="_blank" style="color: #fff; font-size: 14px;padding-left: 15px;">下载用户手册</a> -->
			</div>
			<div v-show="lang === 'en'?true:false">
				<span class="login" v-show='logOutShow' @click='personalCenter'><i
						class="el-icon-s-custom"></i>personal center</span>
				<span class="login" @click="login" v-show='logShow'> <i class="el-icon-s-custom"></i>Player login</span>
				<span class="login" @click="loginOut" v-show='logOutShow' style='margin-left: 10px;'>Log out</span>
				<!-- <a href='https://static.sadong.net/%E9%AB%98%E5%B0%94%E5%A4%AB-%E5%AE%98%E7%BD%91%E7%94%A8%E6%88%B7%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf'
					target="_blank" style="color: #fff; font-size: 14px;padding-left: 15px;">Download User manual</a> -->
			</div>

		</div>
		<!-- logo -->
		<div class="logo">
			<img class="logo-sponsor" src='@/assets/imgs/logo-top.jpg' style="width: 135px;">
		</div>
	<!-- 	<div class="nav">
			<el-menu :default-active="$route.path" mode="horizontal" @select="handleSelect" background-color="#3B7544"
				text-color="#fff" router active-text-color="#F5BB51">
				<el-menu-item index="/homePage">{{$t('route.home')}}</el-menu-item>
				<el-menu-item index="/bonusList">{{$t('route.bonusList')}}</el-menu-item>
				<el-menu-item index="/picture">{{ $t('route.picture') }}</el-menu-item>
				<el-menu-item index="/player">{{$t('route.players')}}</el-menu-item>
				<el-menu-item index="/schedule">{{ $t('route.schedule') }}</el-menu-item>
			</el-menu>
		</div> -->
		<div class="nav" v-show="lang === 'zh-CN'?true:false">
			<el-menu :default-active="$route.path" mode="horizontal" @select="handleSelect" background-color="#3B7544"
				text-color="#fff" router active-text-color="#F5BB51">
				<el-menu-item index="/homePage">首页</el-menu-item>
				<el-menu-item index="/points">积分榜</el-menu-item>
				<el-menu-item index="/bonusList">奖金榜</el-menu-item>
				<el-menu-item index="/picture">图片</el-menu-item>
				<el-menu-item index="/player">球员</el-menu-item>
				<el-menu-item index="/schedule">赛事日程</el-menu-item>
			</el-menu>
		</div>
		<div class="nav" v-show="lang === 'en'?true:false">
			<el-menu :default-active="$route.path" mode="horizontal" @select="handleSelect" background-color="#3B7544"
				text-color="#fff" router active-text-color="#F5BB51">
				<el-menu-item index="/homePage">Home</el-menu-item>
				<el-menu-item index="/points">Points</el-menu-item>
				<el-menu-item index="/bonusList">Prize Money</el-menu-item>
				<el-menu-item index="/picture">Photo</el-menu-item>
				<el-menu-item index="/player">Players</el-menu-item>
				<el-menu-item index="/schedule">Tournaments</el-menu-item>
			</el-menu>
		</div>
		<div class="container">

			<app-main></app-main>

			<div class="partners">
				<el-divider></el-divider>
				<div class="group_18 flex-col">
					<div class="item-partner">
						<span class="item-partner-title"  v-show="lang === 'zh-CN'?true:false">官方战略合作伙伴</span>
						<span class="item-partner-title" v-show="lang === 'en'?true:false">Official Strategic Partner</span>
						<div class="partners-logo">
							<div class="item-logo" v-for="(logoInfo, index) in officialStrategyList" :key="index">
								<img referrerpolicy="no-referrer" :src="logoInfo.imageUrl"
									@click="strategyBtn(logoInfo)" v-if="logoInfo.linkUrl != ''"
									style="cursor:pointer" />
								<img referrerpolicy="no-referrer" :src="logoInfo.imageUrl"
									@click="strategyBtn(logoInfo)" v-else />
							</div>
						</div>
					</div>
					<el-divider></el-divider>
					<div class="item-partner">
						<span class="item-partner-title" v-show="lang === 'zh-CN'?true:false">巡回赛赞助商</span>
						<span class="item-partner-title" v-show="lang === 'en'?true:false">PARTNER</span>
						<div class="partners-logo">
							<div class="item-logo" id="item-logo-type" v-for="(logoInfo, index) in sponsor" :key="index">
								<img class="imgName" referrerpolicy="no-referrer" :src="logoInfo.imageUrl" @click="sponsorBtn(logoInfo)"
									v-if="logoInfo.linkUrl != ''"  />
								<img  class="imgName" referrerpolicy="no-referrer" :src="logoInfo.imageUrl" @click="sponsorBtn(logoInfo)"
									v-else />
							</div>
						</div>
					</div>
					<el-divider></el-divider>
					<div class="item-partner">
						<span class="item-partner-title" v-show="lang === 'zh-CN'?true:false">承办球场</span>
						<span class="item-partner-title"  v-show="lang === 'en'?true:false">Host Course</span>
						<div class="partners-logo">
							<div class="item-logo" v-for="(logoInfo, index) in undertake" :key="index">
								<img referrerpolicy="no-referrer" :src="logoInfo.imageUrl"
									@click="undertakeBtn(logoInfo)" v-if="logoInfo.linkUrl != ''"
									style="cursor:pointer" />
								<img referrerpolicy="no-referrer" :src="logoInfo.imageUrl"
									@click="undertakeBtn(logoInfo)" v-else />

							</div>
						</div>
					</div>
					<el-divider></el-divider>
					<div class="item-partner">
						<span class="item-partner-title" v-show="lang === 'zh-CN'?true:false">联合认证赛事</span>
						<span class="item-partner-title"  v-show="lang === 'en'?true:false">Jointly Certified Events</span>
						<div class="partners-logo">
							<div class="item-logo" v-for="(logoInfo, index) in authentication" :key="index">
								<img referrerpolicy="no-referrer" :src="logoInfo.imageUrl"
									@click="authenticationBtn(logoInfo)" v-if="logoInfo.linkUrl != ''"
									style="cursor:pointer" />
								<img referrerpolicy="no-referrer" :src="logoInfo.imageUrl"
									@click="authenticationBtn(logoInfo)" v-else />

							</div>
						</div>
					</div>
					<el-divider></el-divider>
					<div class="item-partner">
						<span class="item-partner-title" v-show="lang === 'zh-CN'?true:false">合作单位</span>
						<span class="item-partner-title" v-show="lang === 'en'?true:false">PARTNERING ORGANIZATION</span>
						<div class="partners-logo">
							<div class="item-logo" id="item-logo-ogr" v-for="(logoInfo, index) in cooperation" :key="index">
								<img referrerpolicy="no-referrer" :src="logoInfo.imageUrl"
									@click="cooperationBtn(logoInfo)" v-if="logoInfo.linkUrl != ''"
									style="cursor:pointer" />
								<img referrerpolicy="no-referrer" :src="logoInfo.imageUrl"
									@click="cooperationBtn(logoInfo)" v-else />

							</div>
						</div>
					</div>
					<el-divider></el-divider>
					<div class="item-partner">
						<span class="item-partner-title" v-show="lang === 'zh-CN'?true:false">合作媒体</span>
						<span class="item-partner-title" v-show="lang === 'en'?true:false">MEDIA PARTNER</span>
						<div class="item-logo" v-for="(logoInfo, index) in media" :key="index"
							style="width: calc(100% - 140px); margin-left: 20px;">
							<img style="width: 100%;" referrerpolicy="no-referrer" :src="logoInfo.imageUrl"
								@click="mediaBtn(logoInfo)" />
						</div>
					</div>
				</div>
			</div>

		</div>

		<div class="footer-bg">
			<div class="inner flex-col">
				<span class="paragraph_1">© 2017-2025 · All Rights Reserved · competitions.cgagolf.org.cn </span>
				<a href="http://beian.miit.gov.cn/" target="_blank">京ICP备17043983号-2</a>
			</div>
		</div>
	</div>
</template>
<script>
	// import translate from 'i18n-jsautotranslate'

	import AppMain from './components/main'
	import Cookies from "js-cookie"
	import {
		logout,
		contentsListApi
	} from '@/api/user/index.js';
	//内容类型:1轮播图、2、按钮 3、官方战略合作伙伴、4巡回赛赞助商、5、承办球场 6、联合认证赛事 7、合作单位 8、合作媒体 11、热点新闻
	const ContentType = {
		"Banner": 1,
		"Button": 2,
		"Partner": 3,
		"Sponsors": 4,
		"Court": 5,
		"Competition": 6,
		"Unit": 7,
		"Media": 8,
		"HotNews": 11
	}
	export default {
		name: "Layout",
		components: {
			AppMain
		},
		computed: {
			language() {
				return this.$store.getters.language
			}
		},
		data() {
			return {
				queryParams: {
					pageNum: 1,
					pageSize: 100,

				},
				winnerList: [],
				sponsor: [],
				undertake: [],
				authentication: [],
				cooperation: [],
				strategy: [],
				officialStrategyList: [],
				media: [],



				allEventStatus: [{
						status: 0,
					},
					{
						status: 1,
					},
					{
						status: 2,
					}
				],
				activeName: 'first',
				activeIndex: '1',
				dialogVisible: false,
				scoreList: [],
				winnerActive: 0,
				hoverInfo: {},
				paginationInfo: [{
						name: '上一页',
						status: 'prev'
					},
					{
						name: '下一页',
						status: 'next'
					},
				],
				pageNumber: 0,
				allNews: [],
				logOutShow: false,
				logShow: true,
				code: '',
				lang:'zh-CN',
				pathName:''
			};
		},
		created() {
			this.pathName  = window.location.pathname
			this.hoverInfo = this.winnerList[0]
			this.totalCount = this.allNews.length
			this.loginStatus()
			this.$bus.on('loginSuccess', this.loginStatus);

		},

		beforeDestroy() {
			this.$bus.off('loginSuccess', this.loginStatus);
		},

		mounted() {
			this.lang = localStorage.getItem('language')
			if(this.lang === null) {
				localStorage.setItem('language', 'zh-CN')
				this.lang = localStorage.getItem('language')
			}
			this.getSponsorList();
			this.getUndertakeList();
			this.getAuthenticationList();
			this.getCooperationList();
			this.getMediaList();
			this.officialStrategy()
		},
		methods: {
			chBtn(row, index) {
				localStorage.setItem('language', row)
				if(this.pathName === '/openQualification'){
					localStorage.setItem('IdentificationEn','IdentificationEn')
					localStorage.removeItem('Identification')
				}
				this.lang = row || localStorage.getItem('language')
				window.location.reload()
			},
			enBtn(row) {
				localStorage.setItem('language', row)
				if(this.pathName === '/openQualification'){
					localStorage.setItem('Identification','Identification')
					localStorage.removeItem('IdentificationEn')
				}
				this.lang = row || localStorage.getItem('language')
				window.location.reload()
			},
			personalCenter() {
				this.$router.push({
					path: '/userInfo'
				})
			},
			login() {
				this.$router.push({
					path: '/login',
				})
			},
			loginOut() {
				logout().then(res => {
					if (res.data.code == 200) {
						this.$message.success('退出登录')
						Cookies.remove('imToken')
						localStorage.removeItem('code')
						this.logShow = true
						this.logOutShow = false
						location.href = "/homePage"
					}
				})
			},

			//官方战略
			officialStrategy() {
				const data = {
					contentId: ContentType.Partner
				}
				contentsListApi(data).then(res => {
					this.officialStrategyList = res.data.data


				})
			},
			//巡回赛赞助商
			getSponsorList() {
				const data = {
					contentId: 4
				}
				contentsListApi(data).then(res => {
					this.sponsor = res.data.data
				})
			},
			//承办球场
			getUndertakeList() {
				const data = {
					contentId: 5
				}
				contentsListApi(data).then(res => {
					this.undertake = res.data.data
				})
			},

			//联合认证赛事
			getAuthenticationList() {
				const data = {
					contentId: 6
				}
				contentsListApi(data).then(res => {
					this.authentication = res.data.data
				})
			},

			//合作单位
			getCooperationList() {
				const data = {
					contentId: 7
				}
				contentsListApi(data).then(res => {
					this.cooperation = res.data.data
				})
			},
			//合作媒体
			getMediaList() {
				const data = {
					contentId: 8
				}
				contentsListApi(data).then(res => {
					this.media = res.data.data
				})
			},
			/* handleSetLanguage(lang) {
			   console.log(lang)
			   this.$i18n.locale = lang;
			   localStorage.setItem('lang', lang)
			   this.$store.dispatch('app/setLanguage', lang)
			 }, */

			handleSelect(key, keyPath) {
				this.pathName  = keyPath
			},
			//战略跳转
			strategyBtn(row) {

				if (row.type === '0') {

					// window.location.href= row.linkUrl
					window.open(row.linkUrl, '_blank');
				}
			},
			//巡回跳转
			sponsorBtn(row) {

				if (row.type === '0') {

					// window.location.href= row.linkUrl
					window.open(row.linkUrl, '_blank');
				}
			},
			//承办跳转
			undertakeBtn(row) {
				if (row.type === '0') {

					// window.location.href= row.linkUrl
					window.open(row.linkUrl, '_blank');
				}
			},
			//联合跳转
			authenticationBtn(row) {
				if (row.type === '0') {

					// window.location.href= row.linkUrl
					window.open(row.linkUrl, '_blank');
				}
			},
			//单位跳转
			cooperationBtn(row) {
				if (row.type === '0') {

					// window.location.href= row.linkUrl
					window.open(row.linkUrl, '_blank');
				}
			},
			//媒体跳转
			mediaBtn(row) {
				if (row.type === '0') {

					// window.location.href= row.linkUrl
					window.open(row.linkUrl, '_blank');
				}
			},
			// 登录状态显示
			loginStatus() {
				this.code = localStorage.getItem('code')




				if (this.code == 200) {
					this.logOutShow = true
					this.logShow = false
				} else {
					this.logShow = true
					this.logOutShow = false
					Cookies.remove('imToken')
				}
			}

		}
	};
</script>
<style lang="scss" scoped>
	#HomePage {
		width: 1376px;
		margin: 0 auto;
		// background: #dadada  url('../assets/imgs/bg1.jpg') no-repeat center top / 100%
	}

	.header {
		height: 36px;
		line-height: 36px;
		background: url('../assets/imgs/bg-topbar.png');
		transition: all ease 0.6s;
		padding: 0 calc((100% - 1000px) / 2);
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		font-size: 14px;
	}

	.footer-bg {
		background: url('~@/assets/imgs/footer.png') no-repeat center / 100%;
		height: 254px;
		width: 100%;
		z-index: -1;
		bottom: -10px;
	}

	.footer-bg .inner {
		width: 990px;
		margin: 0 auto;
		padding-top: 40px;
		font-size: 16px;
		line-height: 1.6;
		color: #686868;

		a {
			color: #1c773e;
		}
	}

	.login {
		height: 16px;
		font-size: 14px;
		font-family: Alibaba PuHuiTi;
		font-weight: 400;
		color: #FFFFFF;
		cursor: pointer;
	}

	.logo {
		height: 130px;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1376px;
		margin: 0 auto;
	}

	.container {
		width: 1376px;
		margin: 0 auto;

	}

	.nav {
		width: 1376px;
		margin: 0 auto;

	}

	.partners {
		background-color: #fff;
		margin-top: 20px;

		padding: 20px 18px;

	}

	.partners-title {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
		text-align: center;
		line-height: 46px;
		display: block;
		margin-top: 20px;
		display: flex;
	}

	.item-partner {
		display: flex;




	}

	.translate {
		a {
			margin-right: 20px;
			color: #fff;
			display: inline-block;
		}
	}
	#item-logo-type:first-child{
		margin-top:15px;
	}
	#item-logo-ogr:first-child{
		margin-top:14px;
	}
	.imgName:first-child{
		width: 90% !important;
	}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue